// import React, {FC} from 'react'
// import {Currency, QUERIES, SVG, toAbsoluteUrl} from '../../../_metronic/helpers'
// import {useQuery} from 'react-query'
// import {getSalesDashboard} from './core/requests'

// type Props = {
//   value: number
//   title: string
//   progress: number
// }

// const SalesCard: FC<Props> = ({value, title, progress}) => {
//   const color = progress > 0 ? 'success' : progress < 0 ? 'danger' : 'secondary'

//   const path =
//     progress > 0
//       ? toAbsoluteUrl('/media/icons/duotune/arrows/arr056.svg')
//       : progress < 0
//       ? toAbsoluteUrl('/media/icons/duotune/arrows/arr057.svg')
//       : ''

//   return (
//     <div className='col-sm-6 col-md-4 mb-xl-10'>
//       <div className='card'>
//         <div className='card-body d-flex justify-content-between align-items-start '>
//           <div className='d-flex flex-column my-7'>
//             <div className='d-flex gap-1 align-items-center'>
//               <Currency className='fw-semibold  text-gray-800 lh-1 ls-n2 fs-2x' value={value} />
//               <sup className='fs-5 text-muted fw-bold'>TND</sup>
//             </div>
//             <div className='m-0'>
//               <span className='fw-semibold fs-6 text-gray-400'>{title}</span>
//             </div>
//           </div>
//           <span className={`badge badge-light-${color} fs-base`}>
//             <SVG className={`svg-icon-1 svg-icon-${color} ms-n1`} path={path} />
//             {Math.trunc(progress || 0)}%
//           </span>
//         </div>
//       </div>
//     </div>
//   )
// }

// const SalesDashboardSection = () => {
//   const {isFetching, refetch, data} = useQuery(
//     `${QUERIES.SALES_DASHBOARD}`,
//     () => {
//       return getSalesDashboard()
//     },
//     {cacheTime: 0, keepPreviousData: true, refetchOnWindowFocus: false}
//   )

//   if (data)
//     return (
//       <section className='row gy-3 g-xl-3  gx-xl-10'>
//         <SalesCard
//           value={data?.salesWeek || 0}
//           title={'Ventes cette semaine'}
//           progress={data?.progressWeek || 0}
//         />
//         <SalesCard
//           value={data?.salesMonth || 0}
//           title={'Ventes ce mois-ci'}
//           progress={data?.progressMonth || 0}
//         />
//         <SalesCard
//           value={data?.salesYear || 0}
//           title={'Ventes cette année'}
//           progress={data?.progressYear || 0}
//         />
//       </section>
//     )

//   return <div></div>
// }

// export default SalesDashboardSection
import React, {FC} from 'react'
import {Currency, QUERIES, SVG, toAbsoluteUrl} from '../../../_metronic/helpers'
import {useQuery} from 'react-query'
import {getCards} from './core/requests'
import {useAuth} from '../auth'
// import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
// import {faFileInvoice, faUsers, faMoneyCheckAlt, faStar} from '@fortawesome/free-solid-svg-icons'

type Props = {
  value: number
  title: string
  progress: number
  icon: any
  color: string
  colorIcon: string
}

const SalesCard: FC<Props> = ({value, title, icon, color, colorIcon}) => {
  return (
    <div className='col-sm-4 col-md-3 mb-xl-10'>
      <div className='card w-100 h-100' style={{backgroundColor: color}}>
        <div className='card-body d-flex justify-content-between align-items-start '>
          <div className='d-flex flex-column my-6'>
            <div className='m-0'>
              <span className='fw-semibold fs-2 text-gray-800'>{title}</span>
            </div>
            <div className='d-flex gap-1 align-items-center mt-2'>
              <span className='fw-semibold text-gray-800 lh-1 ls-n2 fs-2x'>{value}</span>
            </div>
          </div>
          <span
            className={`badge badge-light fs-base rounded-circle d-flex align-items-center justify-content-center`}
            style={{width: '50px', height: '50px'}}
          >
            <i style={{fontSize: '1.75em', color: `${colorIcon}`}} className={`${icon}`}></i>
          </span>
        </div>
      </div>
    </div>
  )
}

const WelcomeCard = () => {
  const {currentUser} = useAuth()
  return (
    <div className='col-sm-4 col-md-3 mb-xl-10'>
      <div className='card w-100 h-100'>
        <div className='card-body d-flex justify-content-between align-items-start '>
          <div className='d-flex flex-column my-4'>
            <div className='d-flex gap-1 align-items-center'>
              <span className='fw-bold text-gray-800 lh-1 ls-n2 fs-2'>
                Bonjour {currentUser?.company?.name}
              </span>
            </div>
            <div className='m-0 mt-3'>
              <span className='fw-semibold fs-6 text-gray-400'>
                Bienvenue {currentUser?.company?.name} dans votre Espace
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const SalesDashboardSection = () => {
  const {
    isFetching,
    refetch,
    isSuccess,
    data: cards,
  } = useQuery(
    'cards',
    () => {
      return getCards()
    },
    {cacheTime: 0, keepPreviousData: true, refetchOnWindowFocus: false}
  )

  if (cards)
    return (
      <section className='row gy-3 g-xl-3  gx-xl-10'>
        <WelcomeCard />
        <SalesCard
          colorIcon={'#FFAE1A'}
          value={cards?.estimates || '00'}
          title={'Nombre des Devis'}
          progress={0}
          icon={'fa-solid fa-receipt'}
          color={'#FFAE1A1A'}
        />
        <SalesCard
          colorIcon={'#299CDB'}
          value={cards?.invoices || '00'}
          title={'Nombre des factures'}
          progress={0}
          icon={'fa-solid fa-receipt'}
          color={'#299CDB1A'}
        />
        <SalesCard
          colorIcon={'#00AC46'}
          value={cards?.tohave || '00'}
          title={'Nombre des avoirs'}
          progress={0}
          icon={'fa-solid fa-receipt'}
          color={'#00AC461A'}
        />
      </section>
    )

  return <div></div>
}

export default SalesDashboardSection
